import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import { doctorTypesBase } from 'model/User'
import PatientMessagePage from 'model/PatientMessagePage'

export class PatientMessagesRepository extends WebRepository<PatientMessagePage> {
  constructor() {
    super(new Api('patient_messages'))
  }

  async searchAppointmentMessages(
    patientId: string,
    limit: number,
    bookmark: string,
    doctorType?: string,
    userId?: any,
    showAllPatientsMessages?: boolean,
  ): Promise<PatientMessagePage> {
    let selector: { selector: any } = {
      selector: {
        $and: [
          {
            patientId: patientId,
          },
        ],
      },
    }

    if (!showAllPatientsMessages) {
      selector.selector.$and.push({ type: doctorType })
    }

    if (doctorType === doctorTypesBase.primary && !showAllPatientsMessages) {
      selector.selector.$and.push({ userId: userId })
    }

    return super.searchPage({
      selector: selector.selector,
      sort: {
        createdAt: -1,
      },
      limit: limit || 10,
      bookmark: bookmark,
    })
  }
}

export default new PatientMessagesRepository()
